import { Box, Typography } from '@mui/material';
import { IMediaCardProps } from '../../../../constants/types';

const MediaInfoCard = ({ label, description, image }: IMediaCardProps) => (
  <Box className="d-flex flex-column">
    <Box className="d-flex justify-content-center" pt={7} mb={5}>
      <img src={image?.path} alt={image?.alt} width="243px" />
    </Box>
    <Box sx={{ color: 'common.white', textAlign: 'center' }}>
      <Typography variant="h4" mb={2}>
        {label}
      </Typography>
      <Typography variant="body1">{description}</Typography>
    </Box>
  </Box>
);

export default MediaInfoCard;
